(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .filter('karcherEventTranslation', karcherEventTranslation);

  /** @ngInject */
  function karcherEventTranslation($translate) {
    return function (text) {
      if (!text) return;
      switch (text) {
        case 'Base%20exchanger%20regenerated':
          return $translate.instant('KARCHER_EVENT_NAME_1');
        case 'Base%20exchanger%20regeneration%20ended':
          return $translate.instant('KARCHER_EVENT_NAME_2');
        case 'Material%20/%20serial%20number':
          return $translate.instant('KARCHER_EVENT_NAME_3');
        case 'The%20system%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_4');
        case 'HP%20pump%201%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_5');
        case 'HP%20pump%202%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_6');
        case 'HP%20pump%203%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_7');
        case 'HP%20pump%204%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_8');
        case 'HP%20pump%205%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_9');
        case 'Washing%20station%201%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_10');
        case 'Washing%20station%202%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_11');
        case 'Washing%20station%203%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_12');
        case 'Washing%20station%204%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_13');
        case 'Washing%20station%205%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_14');
        case 'Washing%20station%206%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_15');
        case 'Washing%20station%207%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_16');
        case 'Washing%20station%208%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_17');
        case 'Update%20started':
          return $translate.instant('KARCHER_EVENT_NAME_18');
        case 'Update%20finished':
          return $translate.instant('KARCHER_EVENT_NAME_19');
        case 'Start%20WS%20Reg':
          return $translate.instant('KARCHER_EVENT_NAME_20');
        case 'End%20WS%20Reg':
          return $translate.instant('KARCHER_EVENT_NAME_21');
        case 'WS%2075%%20sensor':
          return $translate.instant('KARCHER_EVENT_NAME_22');
        case 'Tech.%20defect':
          return $translate.instant('KARCHER_EVENT_NAME_23');
        case 'Oper.%20defect':
          return $translate.instant('KARCHER_EVENT_NAME_24');
        case 'Unit%20on':
          return $translate.instant('KARCHER_EVENT_NAME_25');
        case 'Unit%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_26');
        case 'Box%201%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_27');
        case 'Box%202%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_28');
        case 'Box%203%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_29');
        case 'Box%204%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_30');
        case 'Box%205%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_31');
        case 'Box%206%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_32');
        case 'Box%207%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_33');
        case 'Box%208%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_34');
        case 'HP%20pump%20bay%201':
          return $translate.instant('KARCHER_EVENT_NAME_35');
        case 'HP%20pump%20bay%202':
          return $translate.instant('KARCHER_EVENT_NAME_36');
        case 'HP%20pump%20bay%203':
          return $translate.instant('KARCHER_EVENT_NAME_37');
        case 'HP%20pump%20bay%204':
          return $translate.instant('KARCHER_EVENT_NAME_38');
        case 'HP%20pump%20bay%205':
          return $translate.instant('KARCHER_EVENT_NAME_39');
        case 'HP%20pump%20bay%206':
          return $translate.instant('KARCHER_EVENT_NAME_40');
        case 'HP%20pump%20bay%207':
          return $translate.instant('KARCHER_EVENT_NAME_41');
        case 'HP%20pump%20bay%208':
          return $translate.instant('KARCHER_EVENT_NAME_42');
        case 'Burner':
          return $translate.instant('KARCHER_EVENT_NAME_43');
        case 'Burner%20fan':
          return $translate.instant('KARCHER_EVENT_NAME_44');
        case 'Warm%20water%20pump':
          return $translate.instant('KARCHER_EVENT_NAME_45');
        case 'Freeze%20prot.pump':
          return $translate.instant('KARCHER_EVENT_NAME_46');
        case 'Osmosis%20pump':
          return $translate.instant('KARCHER_EVENT_NAME_47');
        case 'Floor%20heating':
          return $translate.instant('KARCHER_EVENT_NAME_48');
        case 'Hose%20heating':
          return $translate.instant('KARCHER_EVENT_NAME_49');
        case 'Microe/rim%20clean':
          return $translate.instant('KARCHER_EVENT_NAME_50');
        case 'Underc.%20pump':
          return $translate.instant('KARCHER_EVENT_NAME_51');
        case 'Booster%20pumpFoam':
          return $translate.instant('KARCHER_EVENT_NAME_52');
        case 'Vacuum%20clean.%201':
          return $translate.instant('KARCHER_EVENT_NAME_53');
        case 'Vacuum%20clean.%202':
          return $translate.instant('KARCHER_EVENT_NAME_54');
        case 'Vacuum%20clean.%203':
          return $translate.instant('KARCHER_EVENT_NAME_55');
        case 'Vacuum%20clean.%204':
          return $translate.instant('KARCHER_EVENT_NAME_56');
        case 'Vacuum%20clean.%205':
          return $translate.instant('KARCHER_EVENT_NAME_57');
        case 'Vacuum%20clean.%206':
          return $translate.instant('KARCHER_EVENT_NAME_58');
        case 'Vacuum%20clean.%207':
          return $translate.instant('KARCHER_EVENT_NAME_59');
        case 'Vacuum%20clean.%208':
          return $translate.instant('KARCHER_EVENT_NAME_60');
        case 'Vacuum%20clean.%209':
          return $translate.instant('KARCHER_EVENT_NAME_61');
        case 'Vacuum%20clean.%2010':
          return $translate.instant('KARCHER_EVENT_NAME_62');
        case 'Vacuum%20clean.%2011':
          return $translate.instant('KARCHER_EVENT_NAME_63');
        case 'Vacuum%20clean.%2012':
          return $translate.instant('KARCHER_EVENT_NAME_64');
        case 'Pump%20rim%20clean':
          return $translate.instant('KARCHER_EVENT_NAME_65');
        case 'Pump%20Microe.':
          return $translate.instant('KARCHER_EVENT_NAME_66');
        case 'Pump%20Intensive':
          return $translate.instant('KARCHER_EVENT_NAME_67');
        case 'Vacuum1%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_68');
        case 'Vacuum1%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_69');
        case 'Vacuum2%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_70');
        case 'Vacuum2%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_71');
        case 'Vacuum3%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_72');
        case 'Vacuum3%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_73');
        case 'Vacuum4%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_74');
        case 'Vacuum4%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_75');
        case 'Vacuum5%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_76');
        case 'Vacuum5%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_77');
        case 'Vacuum6%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_78');
        case 'Vacuum6%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_79');
        case 'Vacuum7%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_80');
        case 'Vacuum7%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_81');
        case 'Vacuum8%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_82');
        case 'Vacuum8%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_83');
        case 'Vacuum9%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_84');
        case 'Vacuum9%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_85');
        case 'Vacuum10%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_86');
        case 'Vacuum10%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_87');
        case 'Vacuum11%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_88');
        case 'Vacuum11%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_89');
        case 'Vacuum12%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_90');
        case 'Vacuum12%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_91');
        default:
          return text;
      }
    };
  }
})();
